import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import swal from "sweetalert";
import { deleteUser } from "../../http/index";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const RowEmployee = ({index,data}) =>
{
    const {user} = useSelector(state => state.authSlice); 
    console.log(user)
    const remove = async () =>
    {
        const res = await deleteUser({id:data.id});
        if(res.success)
        {
            toast.success(res.message || "User has been deleted");
            setTimeout(()=>{
                window.location.reload();
            },1500);
        }   
        else
        {
            if(res.message)
                toast.error(res.message);
        }
    }

    const showDialog = () =>
    {  
        swal({
        title: "Are you sure?",
        text: `You want to delete!\n${data.name} \nfrom employees`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((yes) => {
        if (yes)
            remove(); 
      });
    }
    return(
        <tr>
            <td>{index}</td>
            <td><figure className="avatar"> <img src={data.image} alt={data.name}/> </figure></td>
            <td>{data.name}</td>
            <td>{data.email}</td>
            <td>{data.mobile}</td>
            <td><div className={`badge ${data.status==='Active' ? 'badge-primary' :'badge-danger'}`}>{data.status}</div></td>
            
            {
                user.type==="Admin"?
                (<td>
                { data.team ?
                    <NavLink to={`/team/${data.team.id}`} className='badge  badge-primary' style={{padding:'0px 10px 0px 0px'}}>
                    <img src={data.team.image} className='avatar avatar-sm mr-2' alt="Person" width="96" height="96"/>
                    {data.team.name}
                </NavLink>
                :
                <div className='badge  badge-light' style={{padding:'0px 10px 0px 0px'}}>
                    <img src='./assets/icons/team.png' className='avatar avatar-sm mr-2' alt="Person" width="96" height="96"/>
                    No Team
                </div> }
            </td>)
            :""
            }
            {
                user.type==="Admin"?
                (<td>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <NavLink to={`/employee/${data.id}`} className="btn btn-secondary">Detail</NavLink>
                        <button className='btn btn-danger' onClick={showDialog}><i className="fas fa-trash-alt"></i></button>
                    </div>
                </td>)
                :""
            }
        </tr>
    );
}

export default RowEmployee;